import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function CollectionInv(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [invData, setinvData] = useState([]);
  const [ipinvData, setIpinvData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};

 const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};

  useEffect(() => {
      fetchData();
      fetchIpData();
  }, [startDate, endDate]);


  function fetchData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url = `${baseUrl}inv-collection-view/?start_date=${startDateString}&end_date=${endDateString}`;
  axios.get(url)
    .then(response => {
      setinvData(response.data);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  }
   const rows = invData.filter(item => item.inv_paid > 0).map(item => ({
      id: item.id,
      date_time: `${item.add_date_date} ${item.add_time}`,
      appt_id: item.appt_id,
      pat__pat_id: item.pat__pat_id,
      pat__patient: item.pat__patient,
      inv_invoice: item.inv_invoice,
      inv_tot: item.inv_tot,
      inv_paid: item.inv_paid,
      inv_balance: item.inv_balance,
      inv_pmode: item.inv_pmode,
      cashier: item.cashier,
    }));

  const columns = [
    { field: 'date_time', headerName: 'Date', width: 160 },
    { field: 'appt_id', headerName: 'Appt Id', width: 120},
    { field: 'pat__pat_id', headerName: 'Patient ID', width: 100},
    { field: 'pat__patient', headerName: 'Patient', width: 200 },
    { field: 'inv_invoice', headerName: 'Invoice No',
        renderCell: (params) => (
          <Link to={`/inv-invoice-op/${params.row.inv_invoice}`} target="_blank">
            {params.row.inv_invoice}
          </Link>
      ),
      width: 120 },
    { field: 'inv_tot', headerName: 'Invoiced Amount', width: 100 },
    { field: 'inv_paid', headerName: 'Paid Amount', width: 100 },
    { field: 'inv_balance', headerName: 'Balance', width: 100 },
    { field: 'inv_pmode', headerName: 'Payment Mode', width: 110 },
    { field: 'cashier', headerName: 'Cashier', width: 100 },
  ];
  function fetchIpData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url = `${baseUrl}ip-inv-collection-view/?start_date=${startDateString}&end_date=${endDateString}`;
  axios.get(url)
    .then(response => {
      setIpinvData(response.data);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  }
   const rows1 = ipinvData.filter(item => item.inv_paid > 0).map(item => ({
      id: item.id,
      date_time: `${item.add_date_date} ${item.add_time}`,
      appt_id: item.appt_id,
      pat__pat_id: item.pat__pat_id,
      pat__patient: item.pat__patient,
      inv_invoice: item.inv_invoice,
      inv_tot: item.inv_tot,
      inv_paid: item.inv_paid,
      inv_balance: item.inv_balance,
      inv_pmode: item.inv_pmode,
      cashier: item.cashier,
    }));

  const columns1 = [
    { field: 'date_time', headerName: 'Date', width: 160 },
    { field: 'appt_id', headerName: 'Appt Id', width: 120},
    { field: 'pat__pat_id', headerName: 'Patient ID', width: 100},
    { field: 'pat__patient', headerName: 'Patient', width: 200 },
    { field: 'inv_invoice', headerName: 'Invoice No',
        renderCell: (params) => (
          <Link to={`/inv-invoice-ip/${params.row.inv_invoice}`} target="_blank">
            {params.row.inv_invoice}
          </Link>
      ),
      width: 120 },
    { field: 'inv_tot', headerName: 'Invoiced Amount', width: 100 },
    { field: 'inv_paid', headerName: 'Paid Amount', width: 100 },
    { field: 'inv_balance', headerName: 'Balance', width: 100 },
    { field: 'inv_pmode', headerName: 'Payment Mode', width: 110 },
    { field: 'cashier', headerName: 'Cashier', width: 100 },
  ];

  const getTotal = (rows, field) => {
    return rows.reduce((total, row) => total + parseFloat(row[field]), 0);
  };

   const Footer = ({ rows }) => {
      const totalInvoicedAmount = getTotal(rows, 'inv_tot');
      const totalPaidAmount = getTotal(rows, 'inv_paid');
      const totalBalance = getTotal(rows, 'inv_balance');

      return (
        <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '8px' }}>
          <div>Total</div>
          <div>{totalInvoicedAmount}</div>
          <div>{totalPaidAmount}</div>
          <div>{totalBalance}</div>
        </div>
      );
    };

  const getTotal1 = (rows1, field1) => {
    return rows1.reduce((total1, row1) => total1 + parseFloat(row1[field1]), 0);
  };

   const Footer1 = ({ rows1 }) => {
      const totalInvoicedAmount1 = getTotal1(rows1, 'inv_tot');
      const totalPaidAmount1 = getTotal1(rows1, 'inv_paid');
      const totalBalance1 = getTotal1(rows1, 'inv_balance');

      return (
        <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '8px' }}>
          <div>Total</div>
          <div>{totalInvoicedAmount1}</div>
          <div>{totalPaidAmount1}</div>
          <div>{totalBalance1}</div>
        </div>
      );
    };
const today = new Date();

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Radiology Collection Report</h3>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
            selected={startDate}
            onChange={handleStartDateChange}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            maxDate={today}
            placeholderText={'Please select From date'}
            dateFormat="dd/MM/yyyy"
            showMonthDropdown
            showYearDropdown
         />
         <DatePicker
            selected={endDate}
            onChange={handleEndDateChange}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            maxDate={today}
            placeholderText={'Please select To date'}
            dateFormat="dd/MM/yyyy"
            showMonthDropdown
            showYearDropdown
         />

            </div>
          </div>
        </div>
      </div>

      {!isLoading && invData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }} className="mt-4">
        <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> OP Radiology Collection Report</h3>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={rows}
            columns={columns}
            pageSize={10}
            slots={{
              toolbar: GridToolbar,
            }}

            autoHeight
          />
          <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tfoot>
              <Footer rows={rows} />
            </tfoot>
          </table>
        </div>
      ) : (
        <></>
      )}<br></br>
      {!isLoading && ipinvData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }} className="mt-4">
        <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> IP Radiology Collection Report</h3>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={rows1}
            columns={columns1}
            pageSize={10}
            slots={{
              toolbar: GridToolbar,
            }}
            autoHeight
          />
          <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tfoot>
              <Footer1 rows={rows1} />
            </tfoot>
          </table>
        </div>
      ) : (
        <></>
      )}
    </section>
  )
}

export default CollectionInv;
